<template>
  <div>
    <div v-for="role in roles" :key="role">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            v-if="role === 'NOOS_ADMIN'"
            color="#B83835"
          >
            person
          </v-icon>
        </template>
        <span>Administrateur</span>
      </v-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UserRoles',
  props: {
    roles: {
      type: Array,
      required: true,
    },
  },
};
</script>
